import { ChangeDetectionStrategy } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faCalendar } from '@fortawesome/pro-light-svg-icons'
import { faCalendar as faCalendarSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'
import { MenuDrawerStateService } from '@app/navigation/services/menu-drawer-state.service'

@Component({
    selector: 'fm-schedule-link',
    imports: [FaIconComponent, CommonModule, RouterModule, TooltipModule],
    templateUrl: './schedule-link.component.html',
    styleUrl: './schedule-link.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleLinkComponent {
    public faCalendar = faCalendar
    public faCalendarSolid = faCalendarSolid
    public isHovered = false

    constructor(public menuDrawerStateService: MenuDrawerStateService) {}
    onMouseEnter() {
        if (!('ontouchstart' in window)) {
            this.isHovered = true
        }
    }

    onMouseLeave() {
        if (!('ontouchstart' in window)) {
            this.isHovered = false
        }
    }
    // onClickSchedule(): void {
    //     const stackItem: ContentStackItem = {
    //         component: SessionsComponent,
    //         popIfCovered: false,
    //         preserveStack: false,
    //         showRefreshButton: false,
    //         context: { dynamicPanel: true },
    //         sendToMainPanelUrl: 'sessions',
    //     }

    //     this.contentStackService.pushContent(stackItem)
    // }
}
